import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { FormControl, InputLabel, Select } from "@mui/material";
import {
  faCircleCheck,
  faEllipsisV,
  faHistory,
  faInfoCircle,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, Menu, MenuItem, IconButton } from "@mui/material";
import Popup from "../../../base-components/Popup";
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function MemberAttendance() {
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [role , setRole] = useState('')
  const [company_id , setCompanyID] = useState('')
  const [location_id , setLocationID] = useState('')

  const [isSuccessAlert , setIsSuccessAlert] = useState(false)
  const [isFaliureAlert , setIsFailureAlert] = useState(false)
  const [successMessage , setSuccessMessage] = useState('')
  const [failureMessage , setFailureMessage] = useState('')
  const [isPopupOpen , setIsPopupOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState("");
  const [checkInButtonLoading, setCheckInButtonLoading] = useState(false);
  const [checkOutButtonLoading, setCheckOutButtonLoading] = useState(false);
  const [selectedMemberID, setSelectedMemberID] = useState(null);

   useEffect(()=> {
          const sessionStr = sessionStorage.getItem('user-info');
          if(sessionStr){
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
          }
           else {
            navigate('/login');
          }
    },[])

  useEffect(() => {
    if(role) {
      const fetchData = async () => {
        setLoading(true);
        try {
          await Promise.all([
            getMembers()
          ])
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [role]);

  const bufferToBase64 = (buffer) => {
    const uint8Array = new Uint8Array(buffer);
    let binary = '';
    uint8Array.forEach(byte => {
      binary += String.fromCharCode(byte);
    });
    return `data:image/jpeg;base64,${window.btoa(binary)}`;
  };

  async function getMembers() {
    const endpoint =
      role === "SuperAdmin"
        ? "members/get-all-members"
        : role === "Admin"
        ? `members/getMembersByCompanyID/${company_id}?all=true`
        : `members/getMembersByLocationID/${location_id}?all=true`;

    return fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        const membersWithBase64 = data.members.map((member) => {
          if (member.photo?.type === "Buffer") {
            member.photo = bufferToBase64(member.photo.data);
          }
          return member;
        });
  
        const activeMembersWithBase64 = membersWithBase64.filter(member => member.is_active === true);
        setMembers(activeMembersWithBase64);
        // const inactiveMembersWithBase64 = membersWithBase64.filter(member => member.is_active === false);
        // setInactiveMembers(inactiveMembersWithBase64);
        // const restoredMembersWithBase64 = membersWithBase64.filter(member => member.is_restored === true);
        // setRestoredMembers(restoredMembersWithBase64);
        // const newMembersWithBase64 = membersWithBase64.filter(member => member.is_new === true);
        // setNewMembers(newMembersWithBase64);
        // setTabData([
        //     { key: 'inactive', label: 'Inactive Members', members: inactiveMembersWithBase64},
        //     { key: 'active', label: 'Active Members', members: activeMembersWithBase64},
        //     { key: 'all', label: 'All Members', members: membersWithBase64},
        //     { key: 'new', label: 'New Members', members: newMembersWithBase64},
        //     { key: 'restored', label: 'Returning Members', members: restoredMembersWithBase64},
        // ])
      })
      .catch((error) => {
        setMembers([])
        // setActiveMembers([])
        // setInactiveMembers([])
        // setRestoredMembers([])
        // setNewMembers([])
        // setTabData([
        //     { key: "inactive", label: "Inactive Members", members: [] },
        //     { key: "active", label: "Active Members", members: [] },
        //     { key: "all", label: "All Members", members: [] },
        //     { key: "new", label: "New Members", members: [] },
        //     { key: "restored", label: "Returning Members", members: [] },
        //   ]);
      });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCreateAttendance = async(status , member) => {
    
    status === 'checked-in' ? setCheckInButtonLoading(true) : setCheckOutButtonLoading(true);
    setSelectedMemberID(member._id);

    const data = {
      member_id : member._id,
      location_id : member.location_id._id,
      status
    }

    setLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    try{
      const response = await fetch(BASE_URL + `memberAttendance/createMemberAttendance`, requestOptions);
      if(!response.ok) {
        const data = await response.json();
        console.error('Response not ok:', data);
        setIsFailureAlert(true);
        setFailureMessage(data.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }else {
        setIsSuccessAlert(true);
        setSuccessMessage('Attendance Marked Successfully');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (err) {
        console.error('Caught error:', err);
        setIsFailureAlert(true);
        setFailureMessage('Failed to Mark Attendance');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
    } finally {
      setCheckInButtonLoading(false);
      setCheckOutButtonLoading(false);
      setSelectedMemberID(null);
      setLoading(false);
    }
  
  }

  const handleCheckIn = (member) => {
    console.log("Check-In:", member);
  };

  const handleCheckOut = (member) => {
    console.log("Check-Out:", member);
  };

  const handleMoreOptions = (event, member) => {
    setAnchorEl(event.currentTarget);
    setSelectedMember(member);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMember(null);
  };

  const handleSearch = (search) => {
    setSearchQuery(search);
  };

  const lowerQuery = searchQuery.toLowerCase();
  const filteredMembers = members.filter((member) =>{

    const combinedMemberID = `${member?.location_id?.member_id_temp}${member?.member_id}`.toLowerCase();
    return (
        combinedMemberID?.includes(lowerQuery) ||
        member.name.toLowerCase().includes(lowerQuery) ||
        member.location_id?.name.toLowerCase().includes(lowerQuery) ||
        member.package_id.title.toLowerCase().includes(lowerQuery)
    )
  });
  
  return (
    <>
    
      <div className="m-5">
        <PageHeader title="Member Attendance" />
      </div>
      <div className="relative w-auto mx-5 flex items-center gap-4">
  <div className="relative">
    <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
    <input
     type="text"
     placeholder="Search..."
     value={searchQuery}
     onChange={(e) => handleSearch(e.target.value)}
      className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-72"
    />
  </div>

 
</div>

 
      { loading ? (
         
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
          
        ) :  members && members.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Member ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Club</TableCell>
                <TableCell>Package</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {filteredMembers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((member, index) => (
    <TableRow hover key={index}>
      <TableCell>{member.member_id}</TableCell>
      <TableCell>{member.name}</TableCell>
      <TableCell>{member.location_id.name}</TableCell>
      <TableCell>{member?.package_id?.title}</TableCell>
                  {/* <TableCell>{member.is_active ? 'Active' : 'Inactive'}</TableCell> */}
                  <TableCell>
                    <div className="flex gap-4 justify-center items-center">
                   
    {/* Check-In Button */}
 <button
  className={`flex items-center px-2 py-2 bg-green-600 text-white rounded-lg text-sm sm:text-medium font-semibold shadow-md hover:bg-green-700 transition ${checkInButtonLoading && member._id === selectedMemberID ? "cursor-not-allowed bg-gray-400" : ""}`}
  onClick={() => handleCreateAttendance('checked-in', member)}
>
  <FaSignInAlt size={20} />
  <span className="flex ml-2">Check-in {checkInButtonLoading && member._id === selectedMemberID && <CircularProgress size={20} className="ml-2 mt-1" sx={{ color: "white" }} />}</span>
</button>

{/* Check-out Button */}
<button
  className={`flex items-center px-2 py-2 bg-red-600 text-white rounded-lg text-sm sm:text-medium font-semibold shadow-md hover:bg-red-700 transition ${checkOutButtonLoading && member._id === selectedMemberID ? "cursor-not-allowed bg-gray-400" : ""}`}
  onClick={() => handleCreateAttendance('checked-out', member)}
>
  <FaSignOutAlt size={20} />
  <span className="flex ml-2">Check-out {checkOutButtonLoading && member._id === selectedMemberID && <CircularProgress size={20} className="ml-2 mt-1" sx={{ color: "white" }} />}</span>
</button>
                      {/* More Options */}
                      <IconButton
                        color="default"
                        onClick={(event) => handleMoreOptions(event, member)}
                        aria-label="More"
                      >
                        <FontAwesomeIcon icon={faEllipsisV} />
                      </IconButton>

                      {/* Dropdown Menu */}
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && selectedMember === member}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem onClick={() => navigate(`/memberhistory/${member._id}`)}>
                          <FontAwesomeIcon icon={faHistory} className="mr-2" />
                          Member History
                        </MenuItem>
                        <MenuItem 
  onClick={() => navigate("/profilemember", { 
    state: {
      id: member,
      prevPath: "/memberattendance"  
    } 
  })}
>
                          <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                          Member Details
                        </MenuItem>
                      </Menu>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={members.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-full p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}
    

{
  isPopupOpen && (
    <Popup
    onClose={() => setIsPopupOpen(false)}
    alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
    message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
    />
  )
}
</>
  );
}

export default MemberAttendance;
